// project-members-wrapper.component.ts
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ButtonTriggerService } from '../../services/button-trigger.service';
import { UserInvitationsComponent } from '../user-invitations/user-invitations.component';

@Component({
  selector: 'rappider-project-members-wrapper',
  templateUrl: './project-members-wrapper.component.html',
  styleUrls: ['./project-members-wrapper.component.scss']
})
export class ProjectMembersWrapperComponent implements OnDestroy {
  @ViewChild(UserInvitationsComponent) userInvitationsComponent: UserInvitationsComponent;
  private subscriptions: Subscription[] = [];

  constructor(private buttonTrigger: ButtonTriggerService) {
    this.subscribeToButtonTriggers();
  }

  private subscribeToButtonTriggers() {
    this.subscriptions.push(
      this.buttonTrigger.buttonClick$.subscribe((event) => {
        if (event.buttonType === 'openInviteUserModal') {
          this.openInviteUserModal();
        }
      })
    );
  }

  private openInviteUserModal() {
    if (this.userInvitationsComponent) {
      this.userInvitationsComponent.openInviteNewUserModal({
        action: { name: 'Invite User' }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
